import { useQuery } from '@tanstack/react-query';
import { useFormContext, useWatch } from 'react-hook-form';
import { getLineItemOptions } from '@/api/Sherpa/ChangeOrder';
import { HookReactSingleSelect } from '@/components/UI/HookForm/Form/ReactSelect';
import useUpdateEffect from '@/hooks/useUpdateEffect';
import type { BudgetChangeOrderSchema } from './validationSchema';

export function LineItemSelect({ projectId, isDisabled }: { projectId: string; isDisabled?: boolean }) {
  const formMethods = useFormContext<BudgetChangeOrderSchema>();

  const lineItem = useWatch({
    name: 'lineItem',
    control: formMethods.control,
  });

  //Tanstack: version 5 query implementation
  const { data } = useQuery({
    queryKey: ['Line items'],
    queryFn: () => getLineItemOptions({ refType: 'project', refId: Number(projectId) }),
  });

  const lineItemOptions = data?.map((item) => ({
    label: item.name,
    value: item.slug,
    amount: item.amount,
  }));

  useUpdateEffect(() => {
    const currentLineItem = data?.find((option) => option.slug === String(lineItem?.value));

    if (currentLineItem) {
      formMethods.setValue('budgetedAmount', currentLineItem.amount);
    }
  }, [lineItem]);

  return (
    <HookReactSingleSelect
      formMethods={formMethods}
      isDisabled={isDisabled}
      label='Line Item'
      options={lineItemOptions}
      placeholder=''
      name='lineItem'
    />
  );
}
